import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { FormDataContext } from "../../contexts/FormContext";
import { useUpdateCCDataMutation } from "modules/pvs_activities/redux/service/dForm";
import { displayNotification } from "helpers";
import { defaultSingleCCDataTemplate } from "modules/pvs_activities/constants";
import { USER_ROLES } from "constants";

const DynamicCCLOATable = (props) => {
    const siteLanguage = useSelector((s) => s.general.siteLanguage);
    const formDataContext = useContext(FormDataContext);
    const authData = useSelector((s) => s.auth.data);

    const [value, setValue] = useState({ ...defaultSingleCCDataTemplate });
    const [updateCCData, updateCCDataRes] = useUpdateCCDataMutation();

    useEffect(() => {
        setValue({ ...defaultSingleCCDataTemplate, ...props.value });
    }, [props.value]);

    useEffect(() => {
        if (updateCCDataRes.isError) {
            displayNotification('error', 'Error saving Critical Competency Findings data.');
            console.log({ error: updateCCDataRes.error });
        }
    }, [updateCCDataRes]);

    const data = useMemo(() => {
        if (props.ccData.loa_score_texts.length === 0) {
            return [1, 2, 3, 4, 5].map((r) => ({ id: r, loa_text: `${r}. LOA Text Here`, loa_score: r }));
        } else {
            return props.ccData.loa_score_texts.map((r, rk) => ({
                id: r.id,
                loa_text: `${rk + 1}. ${r.loa_text}`,
                loa_score: r.loa_score,
            }));
        }
    }, [props.ccData]);

    const handleOnChange = (e) => {
        const check = data.find((r) => String(r.id) === e.target.value);
        if (check) {
            const obj = { loa_score_id: check.id, content: check.loa_score };
            setValue(obj);
            if (formDataContext.mode === "data_entry") {
                updateCCData({
                    template_id: formDataContext.templateId,
                    section_id: formDataContext.sectionId,
                    element_id: props.elementId,
                    movement_id: formDataContext.movementId,
                    cc_id: props.ccId,
                    key: 'loa_score',
                    ...obj
                });
            }
        }
    }

    return (
        <RadioGroup name={`cc_loa_${props.ccData.id}`}>
            <table className="table table-bordered border-dark">
                <tbody>
                    {props.hasParent === true && (
                        <>
                            <tr className="bg-light-3">
                                <th>DEFINITION</th>
                            </tr>
                            <tr>
                                <td>{props.parentCCDefinitionText !== "" ? props.parentCCDefinitionText : "-"}</td>
                            </tr>
                        </>
                    )}
                    <tr className="bg-light-3">
                        <th>
                            {siteLanguage === "3"
                                ? props.ccData.complete_name_en
                                : siteLanguage === "4"
                                    ? props.ccData.complete_name_fr
                                    : siteLanguage === "5"
                                        ? props.ccData.complete_name_es
                                        : props.ccData.complete_name}
                        </th>
                    </tr>
                    <tr>
                        <td>{props.ccData.definition_text !== "" ? props.ccData.definition_text : "-"}</td>
                    </tr>
                    <tr className="bg-light-3">
                        <th>LEVELS OF ADVANCEMENT</th>
                    </tr>
                    {data.map((s) => (
                        <tr key={s.id}>
                            <td className={String(value.content) === String(s.loa_score) ? "bg-light-primary" : ""}>
                                <FormControlLabel
                                    value={s.id}
                                    onChange={handleOnChange}
                                    checked={String(value.content) === String(s.loa_score)}
                                    control={<Radio />}
                                    label={s.loa_text}
                                    disabled={props.disabled || !USER_ROLES.experts.includes(parseInt(authData.role_id))}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </RadioGroup>
    );
};

DynamicCCLOATable.defaultProps = {
    ccData: {
        id: "",
        complete_name_en: "",
        complete_name_fr: "",
        complete_name_es: "",
        definition_text: "",
        loa_score_texts: [],
    },
    hasParent: true,
    parentCCDefinitionText: "",
    disabled: true,
    value: "",
};

export default DynamicCCLOATable;
